import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Link to="/" className="flex flex-col items-center gap-0.5 mb-5 w-fit">
              <img src="https://hostdost.in/logo.png" alt="Vaana BuildLogic Technologies" className="h-9 w-auto" />
              <span className="text-[#0D72B8] font-bold text-[10px] tracking-[0.25em] font-['Sora'] w-full text-center">Vaana BuildLogic</span>
            </Link>
            <p className="text-[#6B7280] text-sm leading-relaxed">
              Empowering businesses with cutting-edge IT solutions, enterprise resource planning, and cloud infrastructure services.
            </p>
          </div>

          <div>
            <h4 className="text-[#111827] font-semibold text-sm mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {[{to:"/",label:"Home"},{to:"/about",label:"About Us"},{to:"/services",label:"Services"},{to:"/contact",label:"Contact"}].map((l) => (
                <li key={l.to}><Link to={l.to} className="text-[#6B7280] text-sm hover:text-[#0D72B8] transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#111827] font-semibold text-sm mb-5">Services</h4>
            <ul className="space-y-3">
              {[
                {label:"IT Services", slug:"it-services"},
                {label:"ERP Services", slug:"erp-services"},
                {label:"Cloud Services", slug:"cloud-services"},
                {label:"Cyber Security", slug:"cyber-security"},
                {label:"AR / VR Solutions", slug:"ar-vr-solutions"},
                {label:"AI / ML", slug:"ai-ml-deep-learning"},
                {label:"IoT Solutions", slug:"iot-solutions"},
                {label:"AMC / CMC Services", slug:"amc-cmc-services"},
              ].map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-[#6B7280] text-sm hover:text-[#0D72B8] transition-colors">{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#111827] font-semibold text-sm mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-[#0D72B8] mt-0.5 flex-shrink-0" />
                <a href="tel:9953167073" className="text-[#6B7280] text-sm hover:text-[#0D72B8] transition-colors">+91 9953167073</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-[#0D72B8] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@vaanabuildlogictechnologies.com" className="text-[#6B7280] text-sm hover:text-[#0D72B8] transition-colors break-all">info@vaanabuildlogictechnologies.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-[#0D72B8] mt-0.5 flex-shrink-0" />
                <span className="text-[#6B7280] text-sm">Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station, New Delhi 110044</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9CA3AF] text-xs">&copy; {new Date().getFullYear()} Vaana BuildLogic Technologies. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-[#9CA3AF] text-xs hover:text-[#6B7280] transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-[#9CA3AF] text-xs hover:text-[#6B7280] transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
